import { SheetProductsListUI } from './SheetProductsListUI'
import { TSheetProductsListProps } from './types'
import { useSheetProductsList } from './useSheetProductsList'

export function SheetProductsList({ onAddToCart, isLoadingAction, children }: TSheetProductsListProps) {
  const props = useSheetProductsList({ onAddToCart, isLoadingAction, children })

  return <SheetProductsListUI {...props} />
}
